import { isInterfaceType, isObjectType, isUnionType } from "graphql";
import resolveDefault from "./default-mjs";
import resolveList from "./list-mjs";
import resolveObject from "./object-mjs";
import resolveInterface from "./interface-mjs";
import resolveUnion from "./union-mjs";
import { unwrapType } from "../utils-mjs";
export default function mirageGraphQLFieldResolver(obj, args, context, info) {
  var _unwrapType = unwrapType(info.returnType),
      isList = _unwrapType.isList,
      type = _unwrapType.type;

  return isInterfaceType(type) ? resolveInterface(obj, args, context, info, type) : isUnionType(type) ? resolveUnion(obj, args, context, info, isList, type) : !isObjectType(type) ? resolveDefault(obj, args, context, info) : isList ? resolveList(obj, args, context, info, type) : resolveObject(obj, args, context, info, type);
}
